module.exports = __webpack_public_path__ + "img/hotpicklotto_red.fe24aed9.png";